import { Messages } from '../../../gen-src/Localize';
import { RemoteType } from '../../../gen-src/queries/globalTypes';

export const RemoteTypeMappings: Record<RemoteType, () => string> = {
  ARRAY: Messages.RemoteTypeString,
  BOOL: Messages.RemoteTypeBoolean,
  BSTR: Messages.RemoteTypeString,
  BYREF: Messages.RemoteTypeString,
  BYTES: Messages.RemoteTypeString,
  CY: Messages.RemoteTypeReal,
  DATE: Messages.RemoteTypeDate,
  DBDATE: Messages.RemoteTypeDate,
  DBTIME: Messages.RemoteTypeDateTime,
  DBTIMESTAMP: Messages.RemoteTypeDateTime,
  DECIMAL: Messages.RemoteTypeReal,
  EMPTY: Messages.RemoteTypeUnknown,
  ERROR: Messages.RemoteTypeUnknown,
  FILETIME: Messages.RemoteTypeDateTime,
  GUID: Messages.RemoteTypeString,
  HCHAPTER: Messages.RemoteTypeUnknown,
  I1: Messages.RemoteTypeInteger,
  I2: Messages.RemoteTypeInteger,
  I4: Messages.RemoteTypeInteger,
  I8: Messages.RemoteTypeInteger,
  IDISPATCH: Messages.RemoteTypeUnknown,
  IUNKNOWN: Messages.RemoteTypeUnknown,
  NULL: Messages.RemoteTypeInteger,
  NUMERIC: Messages.RemoteTypeReal,
  PROPVARIANT: Messages.RemoteTypeUnknown,
  R4: Messages.RemoteTypeReal,
  R8: Messages.RemoteTypeReal,
  RESERVED: Messages.RemoteTypeUnknown,
  STR: Messages.RemoteTypeString,
  UDT: Messages.RemoteTypeInteger,
  UI1: Messages.RemoteTypeInteger,
  UI2: Messages.RemoteTypeInteger,
  UI4: Messages.RemoteTypeInteger,
  UI8: Messages.RemoteTypeInteger,
  VARIANT: Messages.RemoteTypeUnknown,
  VARNUMERIC: Messages.RemoteTypeReal,
  VECTOR: Messages.RemoteTypeString,
  WDC_BOOL: Messages.RemoteTypeBoolean,
  WDC_DATE: Messages.RemoteTypeDate,
  WDC_DATETIME: Messages.RemoteTypeDateTime,
  WDC_FLOAT: Messages.RemoteTypeReal,
  WDC_GEOMETRY: Messages.RemoteTypeUnknown,
  WDC_INT: Messages.RemoteTypeInteger,
  WDC_STRING: Messages.RemoteTypeString,
  WSTR: Messages.RemoteTypeString
};
